import Vue from 'vue';
import subscriberListTransformer from './../../transformers/subscriberList';
import store from './../../store';


const success = (data, resolve) => {
  store.dispatch('fetchCurrentSubscriberList', subscriberListTransformer.fetch(data));
  resolve();
};

const failed = (errors, reject) => {
  reject(subscriberListTransformer.fetch(errors));
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http
      .get(`subscriberList/${id}`)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriberList/show.js